import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class CompanyAdminGrid extends BaseComponent {
	
	constructor() {
		super();
		
		var companyGrid = this;
		setTimeout(function(){
			companyGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var companyGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							reloadGrid();
						}
					}
				},
				{	
					tag: 'vaadin-combo-box',
					label: 'Filter Field',
					itemid: 'filterField',
					'item-value-path': 'code',
					'item-label-path': 'description',
					style: 'margin-left: 10px;',
					required: true,
					value: 'companyName',
					postinit: function (combo) {
						combo.items = [
							{
								code: 'companyName',
								description: 'Company Name'
							},
							{
								code: 'referenceCode',
								description: 'Reference Code'
							},
							{
								code: 'carrierId',
								description: 'Carrier Id'
							},
							{
								code: 'companyId',
								description: 'Company Id'
							}
						];						
					}
				},				
				{
					tag: 'vaadin-text-field',
					itemid: 'filterValue',
					'class': 'spacer-toolbar-item',
					'keep-open': true,
					label: 'Filter By',					
					listeners: {
						input: {
							fn: function() {
								reloadGrid();
							},
							buffer: 2000
						}
					}
				},								
				{	
					tag: 'vaadin-combo-box',
					itemid: 'status',						
					'class': 'spacer-toolbar-item',
					'item-value-path': 'code',
					'item-label-path': 'desc',
					'prevent-invalid-input': true,
					label: 'Status',
					postinit: function(combo) {							
						combo.items = [
							{
								code: 'A',
								desc: 'Active'
							}, {
								code: 'I',
								desc: 'Inactive'
							}
						];
						combo.value = 'A';
					},
					listeners: {
						change: function() {
							reloadGrid();
						}
					}
				},				
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,					
					permissions: ['ADMIN_COMPANY_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')
					],
					listeners: {
						click: function() {							
							actionEdit(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'dl-action-button',
					itemid: 'companyType',
					'class': 'spacer-toolbar-item',
					disabled: true,					
					permissions: ['ADMIN_COMPANY_MANAGEMENT:MANAGE_COMPANY_TYPE'],
					children:[
						ElementUtil.makeIcon('vaadin:cog', ' Manage Company Type')
					],
					listeners: {
						click: function() {							
							actionManageCompanyType(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'dl-action-button',
					itemid: 'switchCompany',
					'class': 'spacer-toolbar-item',
					disabled: true,
					permissions: ['ADMIN_COMPANY_MANAGEMENT:SWITCH_COMPANIES'],
					children:[
						ElementUtil.makeIcon('vaadin:office', ' Switch')
					],
					listeners: {
						click: function() {
							actionSwitchCompany(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'dl-action-button',	
					theme: 'contrast',
					itemid: 'inactivate',
					disabled: true,
					'class': 'spacer-toolbar-item',
					style: 'float: right; margin-top: 18px;',
					permissions: ['ADMIN_COMPANY_MANAGEMENT:UPDATE_STATUS'],
					children:[
						ElementUtil.makeIcon('vaadin:close', ' Inactivate')
					],
					listeners: {
						click: function() {
							actionInactivate(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'dl-action-button',
					theme: 'success',
					itemid: 'activate',
					disabled: true,
					'class': 'spacer-toolbar-item',
					style: 'float: right; margin-top: 18px;',
					permissions: ['ADMIN_COMPANY_MANAGEMENT:UPDATE_STATUS'],
					children:[
						ElementUtil.makeIcon('vaadin:check', ' Activate')
					],
					listeners: {
						click: function() {
							actionActivate(grid.selectedItems[0]);
						}
					}
				}
			]
		});
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [				
				{						
					path: 'companyId',
					header: 'Company Id',					
					width: '9em'						
				},
				{						
					path: 'companyName',
					header: 'Company Name',						
					'flex-grow': '1'						
				},
				{						
					path: 'referenceCode',
					header: 'Reference Code',						
					width: '5em'						
				},	
				{						
					path: 'carrierId',
					header: 'Carrier Id',						
					width: '5em'						
				},
				{						
					path: 'managementCompany',
					header: 'Management Company',
					'text-align': 'center',
					width: '5em'						
				},
				{						
					path: 'companyType',
					header: 'Company Type',
					'text-align': 'center',
					width: '5em'						
				},
				{						
					path: 'restrictionType',
					header: 'Restriction Type',
					'text-align': 'center',
					width: '5em'						
				},
				{
					path: 'activeStatus',
					header: 'Active Status',					
					'text-align': 'center',
					width: '5em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {
						ElementUtil.query(toolbar, 'edit').disabled = false; 
						ElementUtil.query(toolbar, 'companyType').disabled = false;
						ElementUtil.query(toolbar, 'switchCompany').disabled = false;
						if (item.activeStatus === 'A') {
							ElementUtil.query(toolbar, 'inactivate').disabled = false;
							ElementUtil.query(toolbar, 'activate').disabled = true;
						} else {
							ElementUtil.query(toolbar, 'activate').disabled = false; 
							ElementUtil.query(toolbar, 'inactivate').disabled = true;
						}
					} else {						
						ElementUtil.query(toolbar, 'companyType').disabled = true; 
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'switchCompany').disabled = true;
						ElementUtil.query(toolbar, 'inactivate').disabled = true; 
						ElementUtil.query(toolbar, 'activate').disabled = true; 
					}	
				}
			}
		});
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 100,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
					Service.getCompanyService().loadCompanies({
						offset: pageRange.offset,
						max: pageRange.max,
						sortField: backingGrid.currentSortField,
						sortOrder: backingGrid.currentSortDirection,
						filterValue: ElementUtil.query(toolbar, 'filterValue').value,
						filterField: ElementUtil.query(toolbar, 'filterField').value,
						status: ElementUtil.query(toolbar, 'status').value
					}).then(function(companies){
						loadMask.remove();
						grid.activeItem = null;
						grid.items = companies.data;
						
						pagingToolbar.totalRecords = companies.totalNumber;
						pagingToolbar.updatePager();
					});					
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();
				}
			}
			
		});
		
		
		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'companies',
			onDetail: function() {
				ExportUtil.exportGridItemsAsCsv(grid.items, 'companies.csv');
			}
		});

		var gridLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		companyGrid.append(gridLayout);
		
		var reloadGrid = function() {
			pagingToolbar.loadPage(1);
		};
		
		var actionManageCompanyType = function(record) {
			
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Edit Company Type',
				icon: 'vaadin:edit',
				width: 500,
				height: 300,						
				listeners: {
					ready: function() {						
						addEditWin.show();
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',							
							itemid: 'form',
							children: [							
								{
									tag: 'vaadin-form-layout',										
									children: [																
										{
											tag: 'vaadin-combo-box',
											label: 'Company Type', 
											name: 'companyType',
											'item-value-path': 'code',
											'item-label-path': 'description',											
											postinit: function(combo) {
												Service.getLookupService().getLookupValues('CompanyType').then(function(data){
													combo.items = data;
												});
											}
										},
										{
											tag: 'vaadin-combo-box',
											label: 'Restrict Type', 
											name: 'restrictType',
											'item-value-path': 'code',
											'item-label-path': 'description',								
											postinit: function(combo) {
												Service.getLookupService().getLookupValues('CompanyType').then(function(data){
													combo.items = data;
												});
											}
										},
										{
											tag: 'vaadin-checkbox',									
											name: 'managementCompany',
											label: 'Management Company'
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Update')
													],
													listeners: {
														click: function() {

															if (formPanel.isValid()) {
																var data = formPanel.getData();
																
																var loadMask = formPanel.showLoading('Saving...');
																Service.getCompanyService().updateCompanyType(record.companyId, data).then(function(){
																	loadMask.remove();
																	reloadGrid();
																	
																	addEditWin.close();
																});
															}			
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',									
													listeners: {
														click: function() {
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});					
						
						addEditWin.addToContentElement(formPanel);
						
						record.restrictType = record.restrictionType;						
						formPanel.load(record);
						
					}
				}
			});
			
		};
		
		var actionSwitchCompany = function(record) {
			var loadMask = grid.showLoading('Switching company...');
			Service.getCompanyService().temporarySwitchCompany(record.companyId).then(function(result) {
				if (result && result.success === false) {
					loadMask.remove();
					return;
				}
				return Service.getCompanyService().applyWorkingCompany(record.companyId, false).then(function() {
					window.location.replace('/');
				}, function() {
					console.log('Warning: Failed switch event. Proceeding...');
					window.location.replace('/');
				});
			}, function() {
				loadMask.remove();
			});
		};
		
		var actionEdit = function(record) {
			
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Edit Company',
				icon: 'vaadin:edit',
				listeners: {
					ready: function() {
						
						addEditWin.show();
						
						var companyForm = ElementUtil.create({
							tag: 'dl-company-form',
							listeners: {
								ready: function() {
									companyForm.successCallback = function() {
										reloadGrid();
										addEditWin.close();
									};
									companyForm.addActionButtons(ElementUtil.create({
										tag: 'vaadin-button',
										theme: 'tertiary',
										style: 'margin-left: 10px;',
										innerHTML: 'Cancel',
										listeners: {
											click: function() {
												addEditWin.close();
											}
										}
									}));
								}
							}
						});						
						addEditWin.addToContentElement(companyForm);						
						
						//load form
						var loadMask = addEditWin.showLoading();
						Service.getCompanyService().getCompany(record.companyId).then(function(companyFull){		
							companyForm.loadCompany(companyFull.company.companyId, ElementUtil.objToDotNotation(companyFull));
							loadMask.remove();
						});
						
					}
				}
			});
			
		};
		
		var actionInactivate = function(record) {
			var loadMask = grid.showLoading('Inactivating Company...');
			Service.getCompanyService().inactivateCompany(record.companyId).then(function(updated){
				loadMask.remove();
				reloadGrid();
				window.DL.MessageUtil.showToast('Success', 'Updated Company');
			});
		};
		
		var actionActivate = function(record) {
			var loadMask = grid.showLoading('Activating Company...');
			Service.getCompanyService().activateCompany(record.companyId).then(function(updated){
				loadMask.remove();
				reloadGrid();
				window.DL.MessageUtil.showToast('Success', 'Activated Company');
			});
		};		
	}
	
};
customElements.define('dl-company-grid', CompanyAdminGrid);


